import styled from '@emotion/styled'

import Image from '@segment/matcha/components/Image'
import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'
import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import Elevation from '@segment/matcha/components/Elevation'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import streamlineAccessPng2x from './assets/StreamlineAccess@2x.png'
import streamlineAccessWebp from './assets/StreamlineAccess.webp'
import streamlineAccessWebp2x from './assets/StreamlineAccess@2x.webp'
import streamlineAccessWebp3x from './assets/StreamlineAccess@3x.webp'

const copy = {
  heading: `Streamline access requests`,
}

const features = [
  {
    heading: `Compile user data for access requests`,
    description: `Enable a raw data integration or warehouse to organize data about a given user, so you can easily share it in a structured format if requested.`,
  },
  {
    heading: `Instantly rectify user data`,
    description: `Automatically update user profiles and traits in Segment and in downstream tools whenever new information is received.`,
  },
]

const StreamlineAccess = () => {
  return (
    <SectionBase variant="2Col">
      <SectionCopy>
        <CopyTextBase>
          <CopyText.Heading variant="h2" tag="h2">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description tag="div">
            <ColumnTrackWrapper>
              <ColumnTrack gap="small" columns={1}>
                {features.map((feature) => (
                  <FeatureBoxBase key={feature.heading} alignment="left">
                    <FeatureBox.Body>
                      <FeatureBox.Title>{feature.heading}</FeatureBox.Title>
                      <FeatureBox.Text>{feature.description}</FeatureBox.Text>
                    </FeatureBox.Body>
                  </FeatureBoxBase>
                ))}
              </ColumnTrack>
            </ColumnTrackWrapper>
          </CopyText.Description>
        </CopyTextBase>
      </SectionCopy>
      <SectionContents>
        <Elevation elevation={1} type="dropShadow">
          <picture>
            <source
              type="image/webp"
              srcSet={`${streamlineAccessWebp}, ${streamlineAccessWebp2x} 2x, ${streamlineAccessWebp3x} 3x`}
            />
            <StyledImage
              src={streamlineAccessPng2x}
              alt="Illustration: Streamline access"
              width="602"
              height="427"
              loading="lazy"
            />
          </picture>
        </Elevation>
      </SectionContents>
    </SectionBase>
  )
}

const StyledImage = styled(Image)`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    padding-right: 40px;
  }
`

const SectionCopy = styled(Section.Copy)`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    padding-top: 20px;
    justify-self: end;
    align-self: start;
    width: 75%;
  }
`

const SectionContents = styled(Section.Contents)`
  justify-self: end;
`

const ColumnTrackWrapper = styled.div`
  margin-top: 40px;
`

export default StreamlineAccess
